import styled from 'styled-components';

// ---------------------------------------------------------------------

export default styled.div`
border-radius: 4px 4px 0 0;
box-sizing: border-box;
display: inline-block;
position: relative;
/* min-width: 8rem; */

background: #f5f5f5;
font-family: Roboto,sans-serif;
text-align: left;
font-size: 1rem;
color: rgba(0,0,0,.87);
`;
